import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import uRLs from "../../../utils/baseUtils";
import { CheckIcon, CloseIcon } from "../../../constants/Icons";

const UpdateQty = ({ data, btnLoading, onClose, onEstimateUpdate }) => {
  const [inputValue, setInputValue] = useState(String( uRLs.UNIT === "true" && data?.unitConfig
  ? parseFloat(data.quantity || 1)
  : parseInt(data.quantity || 1, 10)));
  const [errorMessage, setErrorMessage] = useState("");
  const inputRef = useRef(null);
console.log(data)
  const handleUpdate = () => {
    const parsedQuantity =
      uRLs.UNIT === "true" && data?.unitConfig
        ? parseFloat(inputValue)
        : parseInt(inputValue, 10);
  
    if (!isNaN(parsedQuantity) && parsedQuantity >= 1) {
      setErrorMessage("");
      onEstimateUpdate(parsedQuantity);
      onClose();
    } else {
      setInputValue("1");
      setErrorMessage("Please enter a valid quantity (1 or more).");
    }
  };

  const handleInputChange = (e) => {
    let value = e.target.value;
  
    if (uRLs.UNIT === "true" && data?.unitConfig) {
  
      // allow decimal with max 3 digits
      if (!/^\d*\.?\d{0,3}$/.test(value)) {
        return;
      }
  
    } else {
  
      // allow only integer
      value = value.replace(/\D/g, "");
  
      if (!/^\d*$/.test(value)) {
        return;
      }
    }
  
    setInputValue(value);
  
    if (value && parseFloat(value) < 1) {
      setErrorMessage("Quantity must be at least 1.");
    } else {
      setErrorMessage("");
    }
  };

  const handleIncrease = () => {
    setInputValue((prev) => {
      const next = parseInt(prev, 10) || 1;
      return String(next + 1);
    });
  };

  const handleDecrease = () => {
    setInputValue((prev) => {
      const next = parseInt(prev, 10) || 1;
      return String(Math.max(next - 1, 1));
    });
  };

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleUpdate();
    }
  };
  useEffect(() => {
    setInputValue(
      String(
        uRLs.UNIT === "true" && data?.unitConfig
          ? parseFloat(data.quantity || 1)
          : parseInt(data.quantity || 1, 10)
      )
    );
  
    if (!inputRef.current) {
      setErrorMessage("");
    }
  
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [data.quantity]);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="UpdateQtyModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Update Quantity</h6>
              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <h6 className="text-center">{data?.title}</h6>
              <div className="d-flex justify-content-center align-items-center mt-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleDecrease}
                >
                  −
                </button>
                <input
                  type="text"
                  value={inputValue}
                  ref={inputRef}
                  onFocus={(e) => e.target.select()}
                  onChange={handleInputChange}
                  onKeyDown={handleEnterKey}
                  className="form-control text-center mx-2"
                  style={{ width: "80px" }}
                  min="1"
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleIncrease}
                >
                  +
                </button>
              </div>
              {errorMessage && (
                <div className="text-danger text-center mt-2">
                  {errorMessage}
                </div>
              )}
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <CloseIcon iClass={"fs-15"}/> Cancel
              </button>
              {btnLoading ? (
                <button className="btn btn-primary pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  onClick={handleUpdate}
                  type="button"
                  className="btn btn-primary text-right"
                >
                  <CheckIcon/> Update
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateQty;
